import AnalyticsBars, { AnalyticsBarRow } from "./AnalyticsBars";
import AnalyticsCard from "../card/AnalyticsCard";
import AnalyticsHeader from "../header/AnalyticsHeader";
import AnalyticsState from "../state/AnalyticsState";

export type { AnalyticsBarRow };

type Props = {
	title?: string;
	subtitle?: string;
	/** Drawn in the order given — the component does not sort. */
	rows: AnalyticsBarRow[];
	/** Both default to false, for a list built from data that is already in hand. */
	loading?: boolean;
	error?: boolean;
	/** The query's refetch and whether one is already running — see AnalyticsState. */
	onRetry?: () => void;
	retrying?: boolean;
};

/** A labelled horizontal bar per row, in a card of its own. */
const AnalyticsBarList = ({ title, subtitle, rows, loading = false, error = false, onRetry, retrying }: Readonly<Props>) => (
	<AnalyticsCard>
		{/* The heading stays put through every state, so the reader knows what is missing. */}
		{title && <AnalyticsHeader title={title} subtitle={subtitle} />}
		{/* No rows is the empty state: the list has nothing else it could be built from. */}
		<AnalyticsState loading={loading} error={error} onRetry={onRetry} retrying={retrying} empty={rows.length === 0}>
			<AnalyticsBars rows={rows} />
		</AnalyticsState>
	</AnalyticsCard>
);

export default AnalyticsBarList;
